<template>
  <v-dialog v-model="dialog" width="600">
    <gg-card>
      <gg-toolbar @close="close">
        Update Installation
      </gg-toolbar>
      <gg-card-text>
        <v-row>
          <v-col cols="12" class="px-2">
            <p class="mb-0" v-if="installation">
              Update "{{ installation.softdomain }}" {{ installation.script_name }}?
            </p>
          </v-col>
        </v-row>
      </gg-card-text>
      <v-card-actions class="px-5 pt-0 pb-3 justify-content-end">
        <gg-btn secondary @click="close">Cancel</gg-btn>
        <gg-btn :loading="loading" @click="updateInstallation">Update</gg-btn>
      </v-card-actions>
    </gg-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'
import amapi from '@/api/amapi'

export default {
  name: 'UpdateModal',
  mixins: [modalMixin],
  props: {
    installation: {
      type: Object,
      validate (val) {
        return val === null || val.hasOwnProperty('insid')
      }
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    ...mapActions({
      reportError: 'reportError',
      reportSuccess: 'reportSuccess'
    }),
    async updateInstallation () {
      this.loading = true
      const params = {
        method: `upgrade&insid=${this.installation.insid}`,
        payload: {
          softsubmit: 1,
        }
      }
      try {
        const response = await amapi.softaculous_api(params)
        if (!response.done) {
          throw new Error(response.error[0] ?? 'Update error.')
        }
        this.reportSuccess('Installation updated.')
        this.$emit('updated')
        this.close()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
